import * as React from 'react';
import * as classNames from 'classnames';
import './style.css';

export interface FixedAspectProps {
  aspectHeight?: number;
  aspectWidth?: number;
  className?: string;
}

export interface FixedAspectState {
  /* empty */
}

export class FixedAspect extends React.Component<
  FixedAspectProps,
  FixedAspectState
> {
  static get defaultProps(): Partial<FixedAspectProps> {
    return {
      aspectHeight: 9,
      aspectWidth: 16
    };
  }

  render() {
    const { aspectHeight, aspectWidth, children, className } = this.props;

    return (
      <div className={classNames('fixed-aspect', className)}>
        <div
          className="fixed-aspect-filler-element"
          style={{
            paddingTop: `${100 *
              (aspectHeight as number) /
              (aspectWidth as number)}%`
          }}
        />
        <div className="fixed-aspect-content">{children}</div>
      </div>
    );
  }
}

export default FixedAspect;



// WEBPACK FOOTER //
// ./src/app/components/Common/FixedAspect/index.tsx